import TrustCard from "./TrustCard";

interface TrustCardMainProps {
  className: string;
  classNameMain?: string;
  items: any;
}

const TrustCardMain: React.FC< TrustCardMainProps> = ({ className,
  classNameMain,
  items,
 }) => {
  // Split items into two groups for the two columns
  const half = Math.ceil(items.length / 2);
  const topItems = items.slice(0, half);
  const bottomItems = items.slice(half);

  return (
    <div className={`flex flex-col gap-[30px] w-full ${classNameMain}`}>
      <div className={`w-full space-y-8 ${className}`}>
        {topItems.map((item: any, idx: number) => (
          <TrustCard key={idx} logoSrc={item.logoSrc} company={item.company} />
        ))}
      </div>
      <div className={`w-full space-y-8 ${className}`}>
        {bottomItems.map((item: any, idx: number) => (
          <TrustCard key={idx} logoSrc={item.logoSrc} company={item.company} />
        ))}
      </div>
    </div>
  );
};
export default TrustCardMain;